import { render, staticRenderFns } from "./Salers.vue?vue&type=template&id=ab870828&scoped=true"
import script from "./Salers.vue?vue&type=script&lang=js"
export * from "./Salers.vue?vue&type=script&lang=js"
import style0 from "./Salers.vue?vue&type=style&index=0&id=ab870828&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab870828",
  null
  
)

export default component.exports